import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

/**
 * Switch shadcn, in stilul Tailwind v4 folosit in proiect (fara `forwardRef`, cu `data-slot`) —
 * aceeasi forma ca `checkbox.tsx`.
 *
 * De ce `bg-input` pe „oprit", desi `--color-input` (#6E8467) e verde, nu gri: `--color-primary`
 * (#0b632d) e inchis, iar orice gri de putere de control are o luminozitate apropiata de a lui —
 * masurat, `bg-input` vs `bg-primary` da doar **1,82**, iar `muted-foreground` chiar 1,00.
 * O pista deschisa (`bg-muted`) ar da 5,81 intre stari, dar ar cadea la **1,28** fata de cardul
 * alb, adica sub 1.4.11 pentru identificarea componentei — mai rau.
 *
 * Compromisul, asumat: identificarea (`bg-input` 4,07 pe alb, `bg-primary` 8,5 pe alb) si
 * contrastul pastilei (acelasi 4,07 / 8,5) trec amandoua pragul, iar STAREA se citeste din
 * pozitia pastilei — care e la putere de control, nu la 1,82. Diferenta de culoare a pistei
 * ramane un al doilea indiciu, redundant. E si motivul pentru care consumatorul are voie sa
 * scrie „Da"/„Nu" langa: acolo starea e explicita, nu dedusa din nuanta.
 *
 * `peer` pe radacina e cerut de eticheta din `SchoolDetailsFormPage`, care foloseste
 * `peer-disabled:*` — fara el, clasele acelea ar fi inerte.
 */
function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent bg-input shadow-xs transition-colors outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:bg-primary disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className="pointer-events-none block size-4 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
